import { render, staticRenderFns } from "./enInfo.vue?vue&type=template&id=70dda1bc&scoped=true"
import script from "./enInfo.vue?vue&type=script&lang=js"
export * from "./enInfo.vue?vue&type=script&lang=js"
import style0 from "./enInfo.vue?vue&type=style&index=0&id=70dda1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dda1bc",
  null
  
)

export default component.exports